import { doc } from "firebase/firestore";
import { db } from "../firebase/firebase.services";

export const getAdminsRef = () => {
  return doc(db, 'admins/all-admins');
}
